import { useCallback, useContext, useMemo } from 'react';
import { StorageCtx } from './storageCtx';
import { hasValue } from '../helper/type';

export function useStorageSync(key) {
  const storage = useContext(StorageCtx);
  const state = useMemo(() => storage.get(key), [key, storage]);
  const update = useCallback(
    (value) => {
      if (!hasValue(value)) {
        storage.clear(key);
      } else {
        storage.set(key, value);
      }
    },
    [key, storage]
  );

  const clear = useCallback(() => storage.clear(key), [storage, key]);

  return [state, update, clear];
}
